export const SIGNUP_TYPE = {"admin": "admin", "pharmacist": "pharmacist"};
export const IMAGE_SIZE = {"1024": "1024", "128": "128", "1920": "1920", "256": "256", "512": "512"};

export const SEARCH_SELECT_TAGS_TYPE = "tags";
export const SEARCH_SELECT_BLOGS_TYPE = "blogs";
export const SEARCH_SELECT_FOCUS_TYPE = "focus";
export const IMAGE_MAX_SIZE_IN_KB = 150;

export const BANNER_TYPE = {
  "top": "carousel",
  "campaigns": "campaigns",
  "brand_week": "weeklyBrands",
  "promotional_events": "promotionalEvents",
  "dynamic_banner": "dynamic_banner"
};

export const PRODUCT_LIST_TYPE = {
  "hot": "hot",
  "fresh": "fresh",
  "sale": "sale",
  "featured": "featured",
  "CATEGORY": "CATEGORY",
  "SEARCH": "SEARCH",
  "BRAND": "BRAND",
  "PRODUCT_CAMPAIGN": "PRODUCT_CAMPAIGN",
  "PRODUCT_IDS": "PRODUCT_IDS",
  "OTHER": "OTHER",
};

export const PRODUCT_LIST_TYPE_MAPPER = {
  "product-campaigns": PRODUCT_LIST_TYPE.PRODUCT_CAMPAIGN,
  "brands": PRODUCT_LIST_TYPE.BRAND,
  "categories": PRODUCT_LIST_TYPE.CATEGORY,
  "search": PRODUCT_LIST_TYPE.SEARCH,
};

export const PAY_FOR = [
  {
    "label": "Consultations",
    "value": "CONSULTATIONS"
  },
  {
    "label": "Orders",
    "value": "MEDICINES"
  },
  {
    "label": "Campaigns",
    "value": "CAMPAIGNS"
  }
];

export const PLATFORM_WEB = "WEB";
export const PLATFORM_MOBILE = "MOBILE";
export const PLATFORM_BOTH = "BOTH";
export const PLATFORMS = {
  web: {
    "label": "Web",
    "value": PLATFORM_WEB
  },
  mobile: {
    "label": "Mobile",
    "value": PLATFORM_MOBILE
  }
};

export const SOURCE_SYSTEM = {
  JEEVEE: 'JEEVEE',
  SALT: 'SALT',
};

export const SOURCE_SYSTEM_OPTIONS = [
  { value: SOURCE_SYSTEM.JEEVEE, label: SOURCE_SYSTEM.JEEVEE },
  { value: SOURCE_SYSTEM.SALT, label: SOURCE_SYSTEM.SALT },
];

export const genderType = [
  {
    label: 'Male',
    value: 'MALE',
  },
  {
    label: 'Female',
    value: 'FEMALE',
  },
  {
    label: 'Other',
    value: 'OTHERS',
  },
]
